export const constants  = {
    DOCUMENTS: "Documents",
    MAPPING:'Data Mapping',
    STATUS: 'status',
    ADD_SYNONYMS:"Add Synonyms",
    STATUS_UPDATE:"Status Update",
    STATUS_PENDING:"Pending",
    STATUS_FAILED:"Fail",
    STATUS_PASSED:"Success",
    PARTIAL_FAILURE:"Partial Failure",
    PARTIAL_SUCCESS:"Partial Success",
    REVIEWED:"Reviewed",

    MDFD_BY:"HITL",
    doc_columns:[
            { header: "File Name", accessor: "file_name" },
            { header: "Upload Date", accessor: "processed_at" },
            { header: "File Size (mb)", accessor: "file_size" },
            { header: "File Type", accessor: "file_type" },
            { header: "# of Columns", accessor: "no_of_columns" },
            { header: "# of success row", accessor: "success_row_count" },
            { header: "# of failure row", accessor: "failure_row_count" },
            { header: "# of Rows", accessor: "no_of_rows" },
            { header: "Status", accessor: "status" },
            { header: "Failure Reasons", accessor: "failure_reasons" },
            // { header: "Comments", accessor: "comments" },
          ],
     FILE_TYPE:["PDF","DOC","XLSX"]     
    
}